const submitOrder = (
  servicesPath,
  params,
  styleId,
  ss,
  configUrl,
  reservationId,
  chargingUnit,
  bacRegionCode,
  exclusiveCustomer,
  alternateDriveType
) => {
  const {
    country,
    brand,
    lang: language,
    bodystyle: bodyStyle,
    carline,
    modelyear: year,
    postalCode,
  } = params;

  const url = `${servicesPath}/reservation/${language}/${country}/${brand}/${carline}/${year}/${bodyStyle}/${reservationId}`;

  const body = {
    styleId,
    ss,
    postalCode,
    configUrl,
    chargingUnit,
    bacRegionCode,
    exclusiveCustomer,
    ...(alternateDriveType ? { alternateDriveType } : {}),
  };

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(body),
  };
  return fetch(url, options).then((res) => res.status === 200);
};

export default submitOrder;
